var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.canShowJobs)?_c(_setup.VsWrapper,[(_setup.noJobs)?_c('div',{staticClass:"no-jobs"},[_vm._v(" No jobs found at this location."),_c('br'),_vm._v("Try expanding your filters. ")]):_vm._e(),_vm._l((_setup.jobs),function(job){return _c(_setup.FieldViewJobCard,{key:job.id,attrs:{"job":job,"link-to":{
      name: 'fvnext-ticket-info-panel-direct',
      params: {
        id: `${job.number}`,
      },
    }}})}),_c('div',{staticClass:"mt-2"},[(_setup.hasNextPage || _setup.getCurrentPage > 1)?_c(_setup.JobSearchPagination,{attrs:{"query":_setup.jobsQuery,"current-page":_setup.getCurrentPage,"update-page":_setup.updatePage}}):_vm._e()],1)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }